import { useTRPCAPI, useTRPCClientAPI, useTRPCMutation, useTRPCQuery } from '../../../../trpc/trpc';
import type { ListRow } from '../outreachTypes';
import { useInvalidateOutreach } from './useInvalidateOutreach';

/** The contact lists of the artist (frame q1 sidebar) and the list writes. */
export function useOutreachLists(accountId: number) {
  const trpcAPI = useTRPCAPI();
  const trpcClient = useTRPCClientAPI();
  const invalidate = useInvalidateOutreach();
  const query = useTRPCQuery(trpcAPI.outreach.lists.list.queryOptions({ accountId }, { retry: false }));

  const create = useTRPCMutation({
    mutationFn: (name: string) => trpcClient.outreach.lists.create.mutate({ accountId, name }),
    onSuccess: () => invalidate(['lists']),
  });
  const addItems = useTRPCMutation({
    mutationFn: (input: { listUuid: string; workspaceContactUuids: string[] }) =>
      trpcClient.outreach.lists.addItems.mutate({ accountId, ...input }),
    onSuccess: () => invalidate(['lists', 'contacts']),
  });
  const remove = useTRPCMutation({
    mutationFn: (listUuid: string) => trpcClient.outreach.lists.delete.mutate({ accountId, listUuid }),
    onSuccess: () => invalidate(['lists', 'contacts']),
  });

  return {
    lists: (query.data as ListRow[] | undefined) ?? [],
    isLoading: query.isLoading,
    createList: create.mutateAsync,
    addToList: addItems.mutateAsync,
    deleteList: remove.mutateAsync,
    isWriting: create.isPending || addItems.isPending || remove.isPending,
  };
}
